module.exports = __webpack_public_path__ + "188a9351f319cf849f03e2933565f018.svg";


//////////////////
// WEBPACK FOOTER
// ./images/step1-gray.svg
// module id = 1160
// module chunks = 0